// KEEP IDENTICAL WITH TOURNIFY HEROKU SERVER (createPSDTournament)
export default 7;
